import React from 'react'

import './Feed.css'
import FeedItem from './FeedItem'

const FeedList = (props) => {
  //console.log(JSON.stringify(props.activityList));

  const list = props.activityList.map((event, index) => {
    return (
      <FeedItem event={event} key={index} includeImages={props.includeImages}/>
    );
  });

  return (
    <div className="feedlist">
      {list}
    </div>
  );
}

export default FeedList;



// WEBPACK FOOTER //
// ./src/components/FeedList.js